import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const RemainingRevenue = ({ size }) => {
  const { label, value, url, tooltip } = useSelector(
    (state) => state.membershipRevenue.membershipDraft.autopays.remainingRevenue
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue.membershipDraft.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <DataDisplay
      label={label}
      size={size}
      toolTipContent={tooltip || ""}
      type="money"
      url={url}
      currency={currencySymbol}
      value={value}
      disableAnimation={isUserQa}
    />
  );
};

export default RemainingRevenue;
